/**
 * High-level permission groups for team assignment.
 * Org admin can assign these to teams; team users get these permissions.
 */
export const PERMISSION_GROUP_LABELS = {
  job: 'Job Posting',
  assessment: 'Assessment',
  interview: 'AI Interview',
  department: 'Team',
  user: 'User',
  exam: 'Exam',
  candidate: 'Candidate',
  report: 'Report',
  recording: 'Recording',
  billing: 'Billing',
  org: 'Organisation',
};

/** Module keys that represent "high level" areas (Job Posting, Assessment, AI Interview) */
export const HIGH_LEVEL_MODULES = ['job', 'assessment', 'interview'];

/** Group permissions by module for UI */
export function groupPermissionsByModule(permissions) {
  const byModule = {};
  (permissions || []).forEach((p) => {
    const moduleName = p.module || 'other';
    if (!byModule[moduleName]) byModule[moduleName] = [];
    byModule[moduleName].push(p);
  });
  return byModule;
}

/** Get permission keys that the current user (org admin) can assign - from their effective permissions */
export function filterAssignablePermissions(allPermissions, userPermissionKeys) {
  if (!userPermissionKeys || userPermissionKeys.length === 0) return allPermissions;
  const set = new Set(userPermissionKeys.map((k) => (typeof k === 'string' ? k : k?.key)));
  return (allPermissions || []).filter((p) => set.has(p.key) || p.scope === 'department');
}

/** Preset definitions for one-click permission selection. Keys are permission keys from seed. */
export const PERMISSION_PRESETS = {
  all: { label: 'All permissions', modules: null },
  job: { label: 'Job Posting only', modules: ['job'] },
  assessment: { label: 'Assessments only', modules: ['assessment'] },
  interview: { label: 'AI Interview only', modules: ['interview'] },
  view_only: { label: 'View only', actionFilter: 'view' },
  none: { label: 'None', modules: [] },
};
